import { render, staticRenderFns } from "./PopupPrompt.vue?vue&type=template&id=5efab19a&scoped=true&"
import script from "./PopupPrompt.vue?vue&type=script&lang=js&"
export * from "./PopupPrompt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5efab19a",
  null
  
)

export default component.exports